/* Product page behaviour, matching docs/mockups/pdp.html.
 *
 * The mockup's own script is the reference. Where a comment below explains why
 * something is done a particular way, it is because doing it the obvious way
 * was tried in the mockup first and broke.
 */
(function () {
  'use strict';

  var root = document.querySelector('.aps-pdp');
  if (!root) return;

  var bars = [];
  var money = function (cents, symbol) {
    var d = Math.floor(cents / 100), c = cents % 100;
    return '<span class="aps-pn">' + symbol + d.toLocaleString() + '<sup>' + (c < 10 ? '0' : '') + c + '</sup></span>';
  };

  /* ── gallery ─────────────────────────────────────────────────────────── */
  var main = root.querySelector('[data-aps-gal-main]');
  var thumbs = [].slice.call(root.querySelectorAll('.thumbs button'));
  var dots = [].slice.call(root.querySelectorAll('.gdots i'));
  var srcEl = root.querySelector('[data-aps-gal-src]');
  var sources = [];
  try { sources = JSON.parse(srcEl ? srcEl.textContent : '[]'); } catch (e) { sources = []; }

  var gi = 0;
  function show(i) {
    if (!main || !sources.length) return;
    gi = (i + sources.length) % sources.length;
    thumbs.forEach(function (t, n) { t.setAttribute('aria-current', n === gi ? 'true' : 'false'); });
    dots.forEach(function (d, n) { d.classList.toggle('on', n === gi); });
    main.src = sources[gi].src;
    if (sources[gi].alt) main.alt = sources[gi].alt;
  }
  thumbs.forEach(function (b, n) { b.addEventListener('click', function () { show(n); }); });
  dots.forEach(function (d, n) { d.addEventListener('click', function () { show(n); }); });
  root.querySelectorAll('[data-aps-gal]').forEach(function (b) {
    b.addEventListener('click', function () { show(gi + parseInt(b.dataset.apsGal, 10)); });
  });

  /* ── quantity ────────────────────────────────────────────────────────── */
  root.querySelectorAll('.qty').forEach(function (q) {
    var input = q.querySelector('[data-aps-qty-value]');
    if (!input) return;
    q.querySelectorAll('[data-aps-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        var next = (parseInt(input.value, 10) || 1) + parseInt(b.dataset.apsQty, 10);
        input.value = Math.max(1, next);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  /* ── size chips ──────────────────────────────────────────────────────── */
  var dataEl = root.querySelector('[data-aps-variants]');
  var variants = [];
  try { variants = JSON.parse(dataEl ? dataEl.textContent : '[]'); } catch (e) { variants = []; }

  // The specification table lives in its own section, so it is looked up on the
  // document rather than inside the product section's root.
  var specBody = document.querySelector('[data-aps-spec-body]');
  var specMapEl = document.querySelector('[data-aps-spec-map]');
  var specMap = {};
  try { specMap = JSON.parse(specMapEl ? specMapEl.textContent : '{}'); } catch (e) { specMap = {}; }
  var monoLabels = (specBody && specBody.dataset.mono ? specBody.dataset.mono : 'part number,upc,sku,barcode')
    .split(',').map(function (m) { return m.trim().toLowerCase(); }).filter(Boolean);

  var titleEl = root.querySelector('h1.pt');
  var sbarTitle = root.querySelector('[data-aps-sbar-title]');
  var priceBox = root.querySelector('[data-aps-price]');
  var skuEl = root.querySelector('[data-aps-sku]');
  var idInput = root.querySelector('[data-aps-variant-id]');
  var atc = root.querySelector('[data-aps-atc]');
  var sbarPrice = root.querySelector('[data-aps-sbar-price]');
  var symbol = (priceBox && (priceBox.querySelector('.now') || {}).textContent || '$').trim().charAt(0);

  function selectVariant(v) {
    if (!v) return;
    if (idInput) idInput.value = v.id;
    // The part number Liquid chose: the MPN, else the APS number (PSID), else the SKU.
    var apsNo = v.apsn || v.sku;
    if (skuEl && apsNo) skuEl.textContent = apsNo;

    // The title carries the variant, so it moves with the chips. Liquid supplies the
    // base and the separator, so nothing here has to unpick the rendered string.
    var fullTitle = null;
    if (titleEl) {
      fullTitle = titleEl.dataset.append && v.title
        ? titleEl.dataset.base + titleEl.dataset.sep + v.title
        : titleEl.dataset.base;
      titleEl.textContent = fullTitle;
    }
    if (sbarTitle && fullTitle) sbarTitle.textContent = fullTitle;

    // The specification table changes with the variant. Part number, barcode, net
    // weight and count all differ by bucket size, and leaving the 25 lb figures up
    // while the 8 lb is selected is worse than showing nothing.
    if (specBody && specMap[v.id]) {
      specBody.innerHTML = '';
      specMap[v.id].forEach(function (row) {
        var tr = document.createElement('tr');
        var th = document.createElement('th');
        th.textContent = row.label;
        var td = document.createElement('td');
        td.textContent = row.value;
        if (monoLabels.some(function (m) { return row.label.toLowerCase().indexOf(m) !== -1; })) {
          td.className = 'mono';
        }
        tr.appendChild(th); tr.appendChild(td);
        specBody.appendChild(tr);
      });
    }

    if (priceBox) {
      var now = priceBox.querySelector('.now');
      var per = priceBox.querySelector('.per');
      var was = priceBox.querySelector('.was');
      var save = priceBox.querySelector('.save');
      if (now) now.innerHTML = money(v.price, symbol);
      if (per) { per.textContent = v.unit ? '(' + v.unit + ')' : ''; per.hidden = !v.unit; }
      var hasCompare = v.compare && v.compare > v.price;
      if (was) { was.textContent = hasCompare ? v.compareMoney : ''; was.hidden = !hasCompare; }
      if (save) {
        save.hidden = !hasCompare;
        if (hasCompare) {
          var pct = Math.round((v.compare - v.price) * 100 / v.compare);
          save.textContent = pct + (save.dataset.suffix || '');
        }
      }
    }
    if (sbarPrice) sbarPrice.innerHTML = money(v.price, symbol);
    if (atc) atc.disabled = !v.available;
    if (v.image && main) main.src = v.image;
    bars.forEach(function (f) { f(); });

    // Sections outside this one also move with the variant, and they cannot reach in
    // here to find out. Announcing it once is cheaper than each of them polling the
    // chips, and it is the only way a section rendered after this script can react.
    document.dispatchEvent(new CustomEvent('aps:variant', { bubbles: true, detail: v }));
  }

  root.querySelectorAll('.sizes .opt').forEach(function (btn) {
    btn.addEventListener('click', function () {
      root.querySelectorAll('.sizes .opt').forEach(function (o) { o.setAttribute('aria-checked', 'false'); });
      btn.setAttribute('aria-checked', 'true');
      var id = parseInt(btn.dataset.vid, 10);
      selectVariant(variants.filter(function (v) { return v.id === id; })[0]);
      // Keep the address bar honest, so a copied link opens the size that is showing.
      if (window.history && history.replaceState) {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', id);
        history.replaceState({}, '', u);
      }
    });
  });

  /* ── sticky bar ──────────────────────────────────────────────────────── */
  // Deliberately not an IntersectionObserver. On a phone the Add to cart starts
  // below the fold and ends above it without ever intersecting, so no threshold is
  // crossed and the callback never fires. Comparing rects on scroll has no such
  // blind spot. This is a fix, not a preference.
  // The page does not always scroll the window. Horizon puts overflow:auto on
  // .page-wrapper and overflow:hidden on body, so a listener on window never fires
  // and the bar never appears. Measured on the storefront, not assumed.
  //
  // Two traps came with that, and both are why this listens the way it does:
  //
  // Resolving the scroller once at startup finds nothing. This script is deferred,
  // so it runs before images have laid the page out, and at that moment the wrapper
  // is not yet taller than its own box. The scroller is therefore resolved on every
  // update rather than cached.
  //
  // Scroll events do not bubble, so there is nothing useful to listen to on window.
  // They do capture, so one capturing listener on the document hears scrolling from
  // whichever element turns out to own it.
  function scrollerFor(el) {
    for (var n = el.parentElement; n && n !== document.documentElement; n = n.parentElement) {
      var o = getComputedStyle(n).overflowY;
      if ((o === 'auto' || o === 'scroll') && n.scrollHeight > n.clientHeight) return n;
    }
    return null;                       // null means the window scrolls
  }

  function bindBar(button, bar) {
    if (!button || !bar) return;
    function update() {
      var a = button.getBoundingClientRect();
      if (!a.height) { bar.classList.remove('on'); return; }
      var scroller = scrollerFor(bar);
      var top = scroller ? scroller.getBoundingClientRect().top : 0;
      bar.classList.toggle('on', a.bottom < top);
    }
    document.addEventListener('scroll', function () {
      requestAnimationFrame(update);
    }, { capture: true, passive: true });
    bars.push(update);
    // Exposed so the state can be driven directly when verifying. A headless or
    // backgrounded tab never fires requestAnimationFrame, so a scroll test that
    // waits on a frame proves nothing either way.
    window.APSBARS = bars;
    update();
  }
  var sbar = root.querySelector('[data-aps-sticky-bar]');
  bindBar(atc, sbar);

  // The bar is rendered by the section and the title by the block, so the section
  // cannot know whether the variant was appended. Copy it once on load.
  if (titleEl && sbarTitle) sbarTitle.textContent = titleEl.textContent.trim();

  var sbarAdd = root.querySelector('[data-aps-sbar-add]');
  if (sbarAdd && atc) {
    // Submitting through the real button keeps Horizon's product-form-component in
    // charge of the cart drawer and the error states.
    sbarAdd.addEventListener('click', function () { atc.click(); });
  }

  window.addEventListener('resize', function () { bars.forEach(function (f) { f(); }); }, { passive: true });

  /* -- frequently bought together ---------------------------------------- */
  /* Adding to the cart from anywhere on this page, announced the way the drawer
     expects to hear it.

     assets/aps-drawer.js opens on `shopify:cart:lines-update`, and it is strict
     about the shape, which is Horizon's own: `action`, `lines` and `promise` sit
     on the **event object**, not in `detail`, where Horizon puts nothing. It
     returns immediately unless `action` is exactly 'add', it reads
     `lines[0].merchandiseId` to find the line it should paint and gives up if it
     cannot, and it waits on `promise` before reading the cart.

     The bundle used to announce `cart:refresh`, which nothing listens for, so
     adding several add-ons gave no feedback at all. assets/aps-companion.js does
     put its payload in `detail`, and that is deliberate rather than a model to
     copy: the DE filter grid template answers an add with its own modal and must
     not open this panel.

     The promise resolves only after the add has actually landed, so the drawer
     reads a cart that already contains the line rather than racing it. */
  function apsAdd(items) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var done = fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return r.json();
    });

    done.then(function () {
      var e = new CustomEvent('shopify:cart:lines-update', { bubbles: true });
      e.action = 'add';
      e.source = 'aps-pdp';
      e.lines = items.map(function (i) {
        return { quantity: i.quantity, merchandiseId: 'gid://shopify/ProductVariant/' + i.id };
      });
      e.promise = done;
      document.dispatchEvent(e);
    }).catch(function () {});

    return done;
  }

  /* Similar products, and More from the brand. snippets/aps-xc-card.liquid posts a
     real form to /cart/add, and Shopify answers a navigational POST there with a
     redirect to the cart page, so adding from a rail took the reader off the
     product they were reading.

     The form is left exactly as it is and stays the answer with JavaScript off.
     This intercepts the submit and routes it through the same adder, so the drawer
     opens over the page instead. If the add fails the form is submitted for real,
     which lands on the cart page: the behaviour it has always had, rather than a
     click that silently does nothing. */
  document.querySelectorAll('form[data-aps-card-form]').forEach(function (form) {
    /* Bind once. sections/aps-product-rail.liquid and the bundle each pull this
       file in, and a product page carries the bundle plus two rails, so the
       browser executes it four times and four identical <script src> tags do not
       dedupe. Without this guard one click on a card added four times: measured,
       the cart came back holding 2 after a single click. */
    if (form.dataset.apsAddBound) return;
    form.dataset.apsAddBound = '1';
    form.addEventListener('submit', function (ev) {
      var idField = form.querySelector('[name="id"]');
      var id = parseInt(idField && idField.value, 10);
      if (!id) return;
      ev.preventDefault();
      var qtyField = form.querySelector('[name="quantity"]');
      var qty = parseInt(qtyField && qtyField.value, 10) || 1;
      var btn = form.querySelector('button[type="submit"]');
      if (btn) btn.disabled = true;
      apsAdd([{ id: id, quantity: qty }])
        .then(function () { if (btn) btn.disabled = false; })
        .catch(function () { form.submit(); });
    });
  });

  document.querySelectorAll('[data-aps-fbt]').forEach(function (sec) {
    var boxes = [].slice.call(sec.querySelectorAll('.fbt-i input[type=checkbox]'));
    var sum = sec.querySelector('[data-aps-fbt-sum]');
    var btn = sec.querySelector('[data-aps-fbt-add]');
    if (!boxes.length || !sum || !btn) return;

    function update() {
      var total = 0, n = 0;
      boxes.forEach(function (b) {
        var card = b.closest('[data-p]');
        if (b.checked) { total += parseInt(card.dataset.p, 10); n++; }
        card.classList.toggle('off', !b.checked);
      });
      sum.innerHTML = money(total, symbol);
      var tpl = n === 0 ? btn.dataset.none : (n === 1 ? btn.dataset.one : btn.dataset.many);
      // The count replaces the digit in the label, so the wording stays a setting
      // and a translation can put the number wherever that language wants it.
      btn.textContent = tpl.replace(/\d+/, n);
      btn.disabled = !n;
    }
    boxes.forEach(function (b) { b.addEventListener('change', update); });

    /* Same duplicate-execution guard as the cross-sell cards above, and the same
       reason: four copies of this file, four click handlers, four adds. */
    if (btn.dataset.apsAddBound) return;
    btn.dataset.apsAddBound = '1';
    btn.addEventListener('click', function () {
      var items = boxes.filter(function (b) { return b.checked; })
        .map(function (b) { return { id: parseInt(b.closest('[data-vid]').dataset.vid, 10), quantity: 1 }; });
      if (!items.length) return;
      btn.disabled = true;
      apsAdd(items).catch(function () {}).then(function () { btn.disabled = false; });
    });

    update();

    /* the add-on track scrolls by one card, and the fade goes with the last one */
    var track = sec.querySelector('[data-aps-fbt-track]');
    var wrap = sec.querySelector('[data-aps-fbt-wrap]');
    if (track && wrap) {
      var navs = [].slice.call(sec.querySelectorAll('[data-aps-fbt-nav]'));
      function step() { var c = track.querySelector('.fbt-i'); return c ? c.offsetWidth + 42 : 300; }
      function ends() {
        var atEnd = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
        navs.forEach(function (n) {
          n.disabled = parseInt(n.dataset.apsFbtNav, 10) < 0
            ? track.scrollLeft <= 2
            : atEnd;
        });
        wrap.classList.toggle('at-end', atEnd);
      }
      var smooth = !matchMedia('(prefers-reduced-motion: reduce)').matches;
      navs.forEach(function (n) {
        n.addEventListener('click', function () {
          track.scrollBy({ left: parseInt(n.dataset.apsFbtNav, 10) * step(), behavior: smooth ? 'smooth' : 'auto' });
          // Arrows settle their own state; a swipe settles through the scroll event.
          setTimeout(ends, smooth ? 450 : 0);
        });
      });
      track.addEventListener('scroll', ends, { passive: true });
      bars.push(ends);
      ends();
    }
  });

  /* -- card steppers ------------------------------------------------------ */
  document.querySelectorAll('.xc .cq').forEach(function (cq) {
    var out = cq.querySelector('span');
    var field = cq.closest('.buy').querySelector('[data-aps-cq-value]');
    cq.querySelectorAll('[data-aps-cq]').forEach(function (b) {
      b.addEventListener('click', function () {
        var next = Math.max(1, (parseInt(out.textContent, 10) || 1) + parseInt(b.dataset.apsCq, 10));
        out.textContent = next;
        if (field) field.value = next;
      });
    });
  });

  /* -- store reviews, when the product has none --------------------------- */
  // Shopper Approved's widget script sets three globals rather than exposing a
  // callback: sa_widget_overall, sa_widget_overallcount, and sa_widget_contents.
  // It is deferred, so it may land before or after this file; poll briefly rather
  // than assume an order, and give up quietly rather than leave an empty box.
  var storeBox = document.querySelector('[data-aps-store-reviews]');
  if (storeBox) {
    var STAR = '<svg viewBox="0 0 24 24" aria-hidden="true">' +
      '<path d="m12 17.3-6.2 3.7 1.7-7L2 9.2l7.1-.6L12 2l2.9 6.6 7.1.6-5.5 4.8 1.7 7z"/></svg>';

    // Whole and half are not distinguished: the source gives one decimal per review
    // and every review is a whole number of stars, so a filled count is honest.
    function starRow(n) {
      var out = '';
      for (var i = 1; i <= 5; i++) out += '<i class="' + (i <= n ? 'on' : '') + '">' + STAR + '</i>';
      return out;
    }

    // "18 Mar 2026" is what the widget gives. Days are what a reader wants near a
    // review, so recent ones are relative and older ones keep their date.
    function whenText(raw, d) {
      var t = Date.parse(raw);
      if (isNaN(t)) return raw;
      var days = Math.floor((Date.now() - t) / 86400000);
      if (days <= 0) return d.today;
      if (days === 1) return d.day;
      if (days <= 30) return d.days.replace(/\d+/, days);
      return raw;
    }

    var tries = 0;
    (function waitForShopperApproved() {
      if (typeof window.sa_widget_overall === 'undefined') {
        if (++tries > 40) return;                 // ~8s, then leave it hidden
        return setTimeout(waitForShopperApproved, 200);
      }
      var score = String(window.sa_widget_overall);
      var count = parseInt(window.sa_widget_overallcount, 10) || 0;
      if (!count) return;

      var d = storeBox.dataset;
      var pretty = count.toLocaleString();
      var q = function (sel) { return storeBox.querySelector(sel); };

      q('[data-aps-sa-score]').textContent = score;
      q('[data-aps-sa-stars]').innerHTML = starRow(Math.round(parseFloat(score)));
      q('[data-aps-sa-stars]').setAttribute('aria-label', score + ' out of 5');

      var blurb = q('[data-aps-sa-blurb]');
      blurb.innerHTML = '';
      blurb.appendChild(document.createTextNode('Based on '));
      var b = document.createElement('b');
      b.textContent = pretty + ' verified reviews';
      blurb.appendChild(b);
      blurb.appendChild(document.createTextNode(
        ' of ' + d.domain + ' from real customers across all products. This product does not ' +
        'have its own reviews yet, but our store wide rating speaks for the team behind every order.'));

      q('[data-aps-sa-note]').textContent =
        'These reviews are about ' + d.domain + ', not specific to this product.';
      var all = q('[data-aps-sa-all]');
      all.textContent = 'View all ' + pretty + ' reviews on Shopper Approved \u2192';

      var max = parseInt(d.max, 10) || 0;
      var items = Array.isArray(window.sa_widget_contents) ? window.sa_widget_contents : [];
      var list = q('[data-aps-sa-list]');
      if (max && items.length && list) {
        list.innerHTML = '';
        items.slice(0, max).forEach(function (r) {
          // The name arrives as markup from a third party. Take its text and nothing
          // else: this is untrusted content and must never be inserted as HTML.
          var tmp = document.createElement('div');
          tmp.innerHTML = r.name || '';
          var who = (tmp.textContent || '').trim();

          var card = document.createElement('div');
          card.className = 'sarev-i';

          var head = document.createElement('div');
          head.className = 'sarev-i-h';
          var stars = document.createElement('span');
          stars.className = 'stars';
          stars.innerHTML = starRow(Math.round(parseFloat(r.stars) || 0));
          stars.setAttribute('aria-label', (r.stars || '') + ' out of 5');
          var by = document.createElement('span');
          by.className = 'sarev-by';
          by.textContent = who + ' \u00b7 ' + whenText(r.date, { today: d.today, day: d.day, days: d.days });
          var ver = document.createElement('span');
          ver.className = 'sarev-v';
          ver.textContent = '\u2713 ' + d.verified;
          head.appendChild(stars); head.appendChild(by); head.appendChild(ver);

          var body = document.createElement('p');
          body.textContent = (r.comments || '').trim();

          card.appendChild(head); card.appendChild(body);
          list.appendChild(card);
        });
      }

      storeBox.hidden = false;

      // The rating line under the title has nothing of its own on a product with no
      // reviews. Give it the store's, labelled, rather than leaving a gap where a
      // rating belongs.
      var metaSlot = document.querySelector('[data-aps-store-rating]');
      if (metaSlot) {
        metaSlot.querySelector('[data-aps-store-rating-stars]').innerHTML = starRow(Math.round(parseFloat(score)));
        metaSlot.querySelector('[data-aps-store-rating-stars]').setAttribute('aria-label', score + ' out of 5');
        metaSlot.querySelector('[data-aps-store-rating-n]').textContent = score;
        metaSlot.querySelector('[data-aps-store-rating-c]').textContent = '(' + pretty + ')';
        metaSlot.hidden = false;
      }
    })();
  }

  /* -- carousel rows (Similar products) ------------------------------------
     Each row scrolls on its own. An arrow moves one screen of cards; a swipe moves the row
     natively. This file can run more than once,
     since every product section links it, so a row is bound only once. */
  document.querySelectorAll('[data-aps-xrow]').forEach(function (wrap) {
    if (wrap.__apsXrow) return;
    wrap.__apsXrow = true;
    var track = wrap.querySelector('[data-aps-xrow-track]');
    if (!track) return;
    var navs = [].slice.call(wrap.querySelectorAll('[data-aps-xrow-nav]'));
    var smooth = !matchMedia('(prefers-reduced-motion: reduce)').matches;
    // Both arrows show at all times, even at either end of the row. Dylan, 2026-09-11.
    navs.forEach(function (n) {
      n.addEventListener('click', function () {
        track.scrollBy({ left: parseInt(n.dataset.apsXrowNav, 10) * track.clientWidth, behavior: smooth ? 'smooth' : 'auto' });
      });
    });
  });
})();
